import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import heroDish from "@/assets/sfondo.jpeg";
import restaurantInterior from "@/assets/tavoli.webp";
import lakeTrasimeno from "@/assets/location.webp";

import carne from "@/assets/carne.jpeg";
import antipasto from "@/assets/antipasto.jpeg";
import pasta from "@/assets/pasta.jpeg";
import arancini from "@/assets/arancini.jpeg";
import insalata from "@/assets/insalata.jpeg";
import crostata from "@/assets/crostata.webp";
import tavoli from "@/assets/tavoli.webp";
import fuoco from "@/assets/fuoco.webp";
import pesce from "@/assets/pesce.jpeg";
import carneGriglia from "@/assets/carne_griglia.jpeg";
// Immagini ambiente e location
import internoElegante from "@/assets/interno_elegante.webp";
import vistaLago from "@/assets/vista_lago.webp";
import ambienteAccogliente from "@/assets/ambiente_accogliente.webp";
import cucinaVista from "@/assets/cucina_vista.webp";
import dettagliArchitettura from "@/assets/dettagli_architettura.webp";
import cucinaDettagli from "@/assets/cucina_dettagli.webp";

const GalleriaSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [visibleImages, setVisibleImages] = useState(6);
  
  const galleryImages = [
    {
      src: heroDish,
      alt: "Piatto signature Da Armando: pasta fatta in casa con tartufo nero pregiato umbro - cucina tradizionale lago Trasimeno",
      category: "Piatti"
    },
    {
      src: antipasto,
      alt: "Antipasti umbri tradizionali del ristorante Da Armando - salumi locali, formaggi pecorini e bruschette artigianali",
      category: "Antipasti"
    },
    {
      src: internoElegante,
      alt: "Interno elegante ristorante Da Armando a Passignano sul Trasimeno - atmosfera raffinata con vista panoramica sul lago",
      category: "Ambiente"
    },
    {
      src: lakeTrasimeno,
      alt: "Vista panoramica mozzafiato sul Lago Trasimeno dalla terrazza del ristorante Da Armando - location romantica in Umbria",
      category: "Location"
    },
    {
      src: ambienteAccogliente,
      alt: "Atmosfera accogliente del ristorante Da Armando - ambiente familiare e raffinato per cene romantiche e pranzi di famiglia",
      category: "Ambiente"
    },
    {
      src: cucinaDettagli,
      alt: "Dettagli della cucina professionale del ristorante Da Armando - preparazione piatti umbri con ingredienti freschi",
      category: "Cucina"
    },
    {
      src: carne,
      alt: "Carne chianina alla griglia del ristorante Da Armando - bistecca fiorentina e tagliate selezionate Umbria",
      category: "Secondi"
    },
    {
      src: vistaLago,
      alt: "Vista suggestiva ristorante Da Armando sul lago Trasimeno - location ideale per eventi e cerimonie in Umbria",
      category: "Location"
    },
    {
      src: pasta,
      alt: "Pasta fresca fatta in casa quotidianamente al ristorante Da Armando - strangozzi, pappardelle e tagliatelle artigianali",
      category: "Primi"
    },
    {
      src: arancini,
      alt: "Arancini artigianali siciliani del ristorante Da Armando - specialità gastronomiche italiane a Passignano",
      category: "Antipasti"
    },
    {
      src: insalata,
      alt: "Insalata fresca di stagione con verdure biologiche locali - contorni salutari ristorante Da Armando Umbria",
      category: "Contorni"
    },
    {
      src: crostata,
      alt: "Crostata artigianale fatta in casa con marmellata biologica - dolci tradizionali ristorante Da Armando Passignano",
      category: "Dolci"
    },
    {
      src: tavoli,
      alt: "Tavoli elegantemente apparecchiati al ristorante Da Armando - mise en place raffinata per pranzi e cene sul lago Trasimeno",
      category: "Ambiente"
    },
    {
      src: fuoco,
      alt: "Camino tradizionale acceso al ristorante Da Armando - atmosfera calda e romantica per cene invernali in Umbria",
      category: "Atmosfera"
    },
    {
      src: pesce,
      alt: "Pesce fresco del lago Trasimeno al ristorante Da Armando - luccio, persico reale e carpa regina cucinati alla brace",
      category: "Secondi"
    },
    {
      src: carneGriglia,
      alt: "Grigliata mista di carne alla brace ristorante Da Armando - specialità umbra con carni selezionate locali",
      category: "Secondi"
    },
    {
      src: cucinaVista,
      alt: "Cucina a vista del ristorante Da Armando - chef all'opera per preparare piatti tradizionali umbri con passione",
      category: "Cucina"
    },
    {
      src: dettagliArchitettura,
      alt: "Dettagli architettonici caratteristici del ristorante Da Armando - elementi tradizionali umbri e design contemporaneo",
      category: "Dettagli"
    }
  ];

  useEffect(() => {
    const checkIsMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setVisibleImages(mobile ? 3 : 6);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const initialImages = isMobile ? 3 : 6;
  const increment = isMobile ? 3 : 6;
  
  const showMoreImages = () => {
    setVisibleImages(prev => Math.min(prev + increment, galleryImages.length));
  };
  
  const showLessImages = () => {
    setVisibleImages(initialImages);
  };
  
  const displayedImages = galleryImages.slice(0, visibleImages);
  const hasMoreImages = visibleImages < galleryImages.length;
  const showingAllImages = visibleImages >= galleryImages.length;







  return (
    <section id="galleria" className="section-padding bg-muted/30">
      <div className="container-custom">
        <article className="text-center mb-12">
          <h2 className="text-section-title text-primary mb-4">
            Galleria Foto <span className="text-gold">Ristorante</span>
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-body-large text-muted-foreground max-w-2xl mx-auto font-serif">
            Scopri l'atmosfera del <strong>ristorante Da Armando a Passignano sul Trasimeno</strong>: i nostri <strong>piatti tradizionali umbri</strong>, la terrazza panoramica con vista lago, e l'ambiente accogliente che ci contraddistingue. Foto autentiche che raccontano la passione per la <strong>cucina locale</strong> e l'ospitalità umbra.
          </p>
        </article>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayedImages.map((image, index) => (
            <div key={index} className="image-hover group">
              <div className="relative overflow-hidden rounded-2xl shadow-elegant">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="w-full h-80 lg:h-96 object-cover group-hover:scale-110"
                />

              </div>
            </div>
          ))}
        </div>

        {/* Show More/Less Button */}
        <div className="text-center mt-8">
          {hasMoreImages ? (
            <Button 
              onClick={showMoreImages}
              className="bg-accent text-accent-foreground hover:bg-accent/90 border-accent"
            >
              Mostra di più
            </Button>
          ) : showingAllImages && visibleImages > initialImages ? (
            <Button 
              onClick={showLessImages}
              className="bg-accent text-accent-foreground hover:bg-accent/90 border-accent"
            >
              Mostra di meno
            </Button>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default GalleriaSection;